<template>
  <div>

  <modal-cadastro-live ref="modalCadastroLive" :empresas="empresas" :live-edicao="liveEdicao" @liveSalva="buscarLives"/>

    <div class="tab-pane fade show active" id="pills-lives" role="tabpanel" aria-labelledby="pills-lives-tab">
      <div>
        <a href="javascript:void(0)" class="btn btn-primary mr-3 mb-2 mb-md-0" @click="modalCadastrarLive()"><i class="fas fa-plus"></i> Cadastrar Live</a>
        <b-link v-b-toggle="'collapse-filter-lives'" class="btn btn-secondary mr-3 mb-2 mb-md-0"><i class="fas fa-filter"></i> Filtrar lista</b-link>
      </div>
    </div>

    <b-collapse id="collapse-filter-lives" class="filtros mt-3">
      <b-card>
        <form v-on:submit.prevent="buscarLives">
          <div class="row align-items-center">
            <div class="col-12 col-md-11">
              <div class="row">
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Nome da live</label>
                    <input type="text" class="form-control" placeholder="Nome da live" v-model="filtro.live" />
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Vídeo</label>
                    <input type="text" class="form-control" placeholder="Vídeo" v-model="filtro.url_video" />
                  </div>
                </div>
                <div class="col-12 col-md-3">
                  <div class="form-group">
                    <label>Professor</label>
                    <input type="text" class="form-control" placeholder="Professor" v-model="filtro.professor" />
                  </div>
                </div>
                <div class="col-12 col-md-5">
                  <div class="form-group">
                    <label><input type="checkbox" v-model="filtro.createdDate" /> Filtrar por data da Live </label>
                    <date-range-picker
                      v-if="filtro.createdDate"
                      ref="picker"
                      :auto-apply="true"
                      opens="center"
                      v-model="filtro.createdDateRange"
                      :locale-data="dateRangeLocale"
                      :ranges="filtrosDateRangePredefinidos">
                    </date-range-picker>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-1">
              <button type="submit" class="btn-primary btn-filtros-busca"><i class="fas fa-search"></i></button>
            </div>
          </div>
        </form>
      </b-card>
    </b-collapse>

    <p class="text-right mt-3" v-if="quantidade"><strong>{{ quantidade }}</strong> itens</p>
    <div class="table-responsive tabela-usuarios mt-2 position-relative" v-if="lives.length">
      <table class="table" ref="resultadoTabelalives">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Vídeo</th>
            <th>Data Prevista Início</th>
            <th>Data Prevista Fim</th>
            <th>Professor</th>
            <th>Criador</th>
            <th v-if="!isB2B">Empresas</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="live in lives" v-bind:key="'live'+live.id">
            <td :title="live.id">{{ live.live }}</td>
            <td>{{ live.url_video }}</td>
            <td>{{ live.datahora_prevista_inicio | formatDatetime }}</td>
            <td>{{ live.datahora_prevista_fim | formatDatetime }}</td>
            <td>{{ live.professor }}</td>
            <td>{{ live.criador.name }}</td>
            <td v-if="!isB2B">{{ live.empresas.length }}</td>
            <td>
              <div class="d-flex align-items-center">
                <a href="javascript:void(0)" v-b-tooltip.hover title="Editar" @click="modalEditarLive(live)"><i class="fas fa-edit"></i></a>
                <a href="javascript:void(0)" v-b-tooltip.hover title="Excluir" @click="deletarLive(live)"><i class="fas fa-trash-alt"></i></a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <transition name="fade">
        <div class="btn-top text-center d-block" v-if="scrolled">
          <a href="javascript:void(0)" @click="scrollToTop"><i class="fas fa-chevron-circle-up"></i>ir para o topo</a>
        </div>
      </transition>

    </div>

    <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
      <div slot="no-results">Sua busca não retornou resultados</div>
      <div slot="no-more"></div>
    </infinite-loading>
  </div>
</template>

<script>
import ModalCadastroLive from '@/modules/Live/components/ModalCadastroLive'
import InfiniteLoading from 'vue-infinite-loading'
import DateRangePicker from 'vue2-daterange-picker/src/components/DateRangePicker'
import LiveAPI from '@/api/live-api'
import EmpresaAPI from '@/api/empresa-api'
import DateUtils from '@/core/util/date-utils'
import moment from 'moment'
import Swal from 'sweetalert2'
import ResponseUtils from '@/core/util/response-utils'
import EmpresaUtils from '@/core/util/empresa-utils'

export default {
  name: 'Listalives',
  components: { DateRangePicker, InfiniteLoading, ModalCadastroLive },

  data () {
    return {
      pagina: 1,
      quantidade: 0,
      lives: [],
      liveEdicao: null,
      infiniteId: new Date(),
      scrolled: false,
      empresas: [],
      filtro: {
        id: '',
        live: '',
        url_video: '',
        createdDateRange: {
          startDate: DateUtils.formatDate(DateUtils.create().subtract(1, 'month').toDate()),
          endDate: DateUtils.formatDate(new Date())
        }
      },
      filtrosDateRangePredefinidos: {
        'Esta semana': [moment().startOf('week'), moment().endOf('week')],
        'Última semana': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
        'Este mês': [moment().startOf('month'), moment().endOf('month')],
        'Último mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'Este ano': [moment().startOf('year'), moment().endOf('year')]
      },
      dateRangeLocale: {
        direction: 'ltr',
        format: 'DD/MM/YYYY',
        separator: ' - ',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez']
      }
    }
  },

  computed: {
    isB2B: function () {
      return (EmpresaUtils.getEmpresa().b2b === 1)
    }
  },

  created () {
    window.addEventListener('scroll', this.handleScroll)
  },

  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },

  mounted () {
    EmpresaAPI.listar().then(data => {
      this.empresas = data
    })
  },

  methods: {
    handleScroll: function (event) {
      this.scrolled = window.scrollY > 100
    },

    scrollToTop: function () {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    },

    modalCadastrarLive: function () {
      this.liveEdicao = null

      this.$nextTick(() => {
        this.$refs.modalCadastroLive.show()
      })
    },

    modalEditarLive: function (live) {
      this.liveEdicao = live

      this.$nextTick(() => {
        this.$refs.modalCadastroLive.show()
      })
    },

    buscarLives: function () {
      this.quantidade = 0
      this.pagina = 1
      this.infiniteId = new Date()
      this.lives = []
    },

    infiniteHandler: function ($state) {
      LiveAPI.listar(this.pagina, this.filtro, EmpresaUtils.getEmpresa().id).then(data => {
        this.quantidade = data.total

        if (this.pagina <= data.last_page) {
          this.lives.push(...data.data.map(item => {
            return item
          }))
          $state.loaded()

          if (this.pagina === data.last_page) {
            $state.complete()
          } else {
            this.pagina += 1
          }
        } else {
          $state.complete()
        }
      })
    },

    deletarLive: async function (live) {
      let resultSwalModalFired = await Swal.fire({
        title: 'Você deseja excluir essa live?',
        text: 'Essa ação não poderá ser revertida!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, excluir live!',
        cancelButtonText: 'Cancelar'
      })
      if (resultSwalModalFired.value) {
        const loader = this.$loading.show()

        try {
          await LiveAPI.deletar(live)
          loader.hide()

          await Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Live excluida com sucesso'
          })
          this.buscarLives()
        } catch (error) {
          ResponseUtils.handleError(error, loader)
        }
      }
    }

  }
}
</script>

<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
</style>
